// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"5419dadc","174":"0c0878e0","506":"544d4885","838":"17255b45","961":"b5d79706"}[chunkId] + ".css";
};